export enum CommunicationsResponseConferenceEndError {
  unableToEndConference = 'unableToEndConference',
}
